import {ApmHelper} from "../domains2/libraries/ApmHelper";

const trackers = {};

export const CUSTOM_APM_TRANSACTION_KEYS = Object.freeze({
	PRODUCT_CATALOG_TRANSITION: "productCatalogTransition",
	CONFIGURABLE_PRODUCT_CLICKED: "configurableProductTransition",
	GO_TO_BASKET_CLICKED: "goToBasketClicked",
	ADD_TO_BASKET_CLICKED:	"addToBasketClicked"
});

export const CUSTOM_APM_SPAN_NAMES = Object.freeze({
	DELIVERY_METHOD_CLICKED: "deliveryMethodClicked",
	PRODUCT_CLICKED: "productClicked",
	GO_TO_BASKET_CLICKED:	"goToBasketClicked",
	ADD_TO_BASKET_CLICKED:	"addToBasketClicked"
});

export const CUSTOM_APM_TRANSACTION_NAMES = Object.freeze({
	LANDING_PAGE_TO_PRODUCT_CATALOG_TRANSITION: "LandingPageToProductCatalogTransition",
	DELIVERY_METHODS_TO_PRODUCT_CATALOG_TRANSITION: "DeliveryMethodsToProductCatalogTransition",
	PRODUCT_CATALOG_TO_MENU_PRODUCT_DETAILS_TRANSITION_STEPPER: "ProductCatalogToMenuProductDetailsTransitionStepper",
	PRODUCT_CATALOG_TO_MENU_PRODUCT_DETAILS_TRANSITION_SINGLE: "ProductCatalogToMenuProductDetailsTransitionSingle",
	PRODUCT_CATALOG_TO_REGULAR_PRODUCT_DETAILS_TRANSITION_STEPPER: "ProductCatalogToRegularProductDetailsTransitionStepper",
	PRODUCT_CATALOG_TO_REGULAR_PRODUCT_DETAILS_TRANSITION_SINGLE: "ProductCatalogToRegularProductDetailsTransitionSingle",
	PRODUCT_CATALOG_TO_MENU_PRODUCT_DETAILS_TRANSITION: "ProductCatalogToMenuProductDetailsTransition",
	PRODUCT_CATALOG_TO_REGULAR_PRODUCT_DETAILS_TRANSITION: "ProductCatalogToRegularProductDetailsTransition",
	PRODUCT_CATALOG_TO_CHECKOUT_TRANSITION: "ProductCatalogToCheckoutTransition",
	ADD_TO_BASKET_CONFIGURABLE_PRODUCT:	"AddToBasketConfigurableProduct"
});

export default {
	start(key, trName, spanName, options) {
		if (!window.elasticApm) return;

		const tr = window.elasticApm.startTransaction(trName, options	&& options.type || "user-interaction");
		if(options && options.flow) {
			ApmHelper.addLabel("flow", options.flow);
		}
		if(options && options.productId) {
			ApmHelper.addLabel("productId", options.productId);
		}
		const sp = tr && tr.startSpan(spanName);
		trackers[key] = { tr, sp };
	},

	end(key) {
		const tracker = trackers[key];
		if (!tracker) return;
		if (tracker.sp) tracker.sp.end();
		if (tracker.tr) tracker.tr.end();
		delete trackers[key];
	}
};
